import { render, staticRenderFns } from "./codprice.vue?vue&type=template&id=1cee113c"
import script from "./codprice.vue?vue&type=script&lang=js"
export * from "./codprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports